import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import { HiAnnotation, HiBeaker, HiBookmarkAlt, HiBookOpen, HiChartPie, HiKey, HiUserGroup } from "react-icons/hi";
import { FiBookOpen } from "react-icons/fi";

import { toTitleCase } from "../utils/Helper";
import { accessItems, caseStudyModule, dashboardItems, diagnosisItems, helpItems, organItems, questionItems, reportItems, searchItems, systemItems, userItems } from "../utils/MenuItems";

const { SubMenu } = Menu;

const TopicMenu = ({ onClick }) => {
  const location = useLocation();

  const [path, setPath] = useState("");

  useEffect(() => {
    setPath(location.pathname);
    const firstSplittedString = location.pathname.split("/")[1];
    const replacedString = firstSplittedString.replace("-", " ");
    document.title = `${toTitleCase(replacedString)} - RadMe`;
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div>
      <Menu mode='inline' selectedKeys={[path.split("/")[1]]} onClick={() => onClick()}>
        {dashboardItems.map((el) => (
          <Menu.Item key={el.to} icon={el.icon}>
            {el.name} <Link to={el.to} />
          </Menu.Item>
        ))}

        <SubMenu key='system' icon={<HiBookOpen />} title='System'>
          {systemItems.map((el) => (
            <Menu.Item key={el.to} icon={el.icon}>
              {el.name} <Link to={el.to} />
            </Menu.Item>
          ))}
        </SubMenu>

        <SubMenu key='organ' icon={<HiBeaker />} title='Organs'>
          {organItems.map((el) => (
            <Menu.Item key={el.to} icon={el.icon}>
              {el.name} <Link to={el.to} />
            </Menu.Item>
          ))}
        </SubMenu>

        <SubMenu key='diagnosis' icon={<HiBookmarkAlt />} title='Diagnosis'>
          {diagnosisItems.map((el) => (
            <Menu.Item key={el.to} icon={el.icon}>
              {el.name} <Link to={el.to} />
            </Menu.Item>
          ))}
        </SubMenu>

        <SubMenu key='question' icon={<HiAnnotation />} title='Questions'>
          {questionItems.map((el) => (
            <Menu.Item key={el.to} icon={el.icon}>
              {el.name} <Link to={el.to} />
            </Menu.Item>
          ))}
        </SubMenu>

        <SubMenu key='access' icon={<HiKey />} title='Manage Access'>
          {accessItems.map((el) => (
            <Menu.Item key={el.to} icon={el.icon}>
              {el.name} <Link to={el.to} />
            </Menu.Item>
          ))}
        </SubMenu>

        <SubMenu key='users' icon={<HiUserGroup />} title='Users'>
          {userItems.map((el) => (
            <Menu.Item key={el.to} icon={el.icon}>
              {el.name} <Link to={el.to} />
            </Menu.Item>
          ))}
        </SubMenu>

        <SubMenu key='report' icon={<HiChartPie />} title='Reports'>
          {reportItems.map((el) => (
            <Menu.Item key={el.to} icon={el.icon}>
              {el.name} <Link to={el.to} />
            </Menu.Item>
          ))}
        </SubMenu>

        <SubMenu key='case_study' icon={<FiBookOpen />} title='Case Study Module'>
          {caseStudyModule.map((el) => (
            <Menu.Item key={el.to} icon={el.icon}>
              {el.name} <Link to={el.to} />
            </Menu.Item>
          ))}
        </SubMenu>

        {searchItems.map((el) => (
          <Menu.Item key={el.to} icon={el.icon}>
            {el.name} <Link to={el.to} />
          </Menu.Item>
        ))}

        {helpItems.map((el) => (
          <Menu.Item key={el.to} icon={el.icon}>
            {el.name} <Link to={el.to} />
          </Menu.Item>
        ))}
      </Menu>
    </div>
  );
};

export default TopicMenu;
